import toast from "react-hot-toast";
import { Img } from "react-image";
import { useNavigate } from "@tanstack/react-router";
import { UserAPI } from "@repo/api/user";
import BaseModal from "@/components/modal/base-modal";
import { useState } from "react";
import { Button } from "@heroui/react";

export function Badge({
  id = "0",
  title = "奇怪的徽章",
  img = "99ECC3B98A15281E83C45BF9D2F11DC9.png",
  collectable = false,
  quality = 0,
}: Readonly<{
  id: string;
  title: string;
  img: string;
  gotAt: number;
  collectable: boolean;
  quality: number;
}>) {
  const navigate = useNavigate();
  return (
    <div onClick={() => navigate({ to: "/user/badges/$id", params: { id: String(id) } })} className={"flex flex-col items-center"}>
      <Img
        src={img}
        alt={title}
        className={"cursor-pointer drop-shadow-lg transition-all hover:scale-110"}
      />
      {!collectable && (
        <div className={"flex flex-col items-center"}>
          <div className={"text-sm font-bold"}>{title}</div>
          <div
            className={"text-xs"}
            style={{
              color: GetQuality(quality).color,
            }}
          >
            {GetQuality(quality).text}
          </div>
        </div>
      )}
      {collectable && <div className={"text-xs text-orange-400"}>可领取</div>}
    </div>
  );
}

export function CollectableBadge({
  id,
  title = "奇怪的徽章",
  img = "99ECC3B98A15281E83C45BF9D2F11DC9.png",
  refresh,
}: Readonly<{ id: string; title: string; img: string; refresh: () => void }>) {
  const [open, setOpen] = useState(false);
  const onConfirm = () => {
    UserAPI.collectBadge(id).then(
      () => {
        toast.success("领取成功");
        refresh();
        setOpen(false);
      },
      (err) => toast.error(err.msg),
    );
  };
  return (
    <>
      <div className={"flex flex-col items-center"} onClick={() => setOpen(true)}>
        <Img
          src={img}
          alt={title}
          className={"cursor-pointer drop-shadow-lg transition-all hover:scale-110"}
          style={{ filter: "grayscale(100%)" }}
        />
        <div className={"text-xs text-orange-400"}>可领取</div>
      </div>
      <BaseModal
        open={open}
        showCancel={false}
        showConfirm={false}
        onClose={() => setOpen(false)}
      >
        <div>
          <div className="flex flex-col gap-1">确定领取这个徽章吗？</div>
          <div>
            <Img src={img} alt={title} className={"drop-shadow-lg"} />
          </div>
          <div>
            <Button className={"w-full"} onPress={onConfirm}>
              确定领取
            </Button>
          </div>
        </div>
      </BaseModal>
    </>
  );
}

export const GetQuality = (quality: number) => {
  switch (quality) {
    case 0:
      return {
        color: "gray",
        text: "普通",
      };
    case 1:
      return {
        color: "green",
        text: "稀有",
      };
    case 2:
      return {
        color: "orange",
        text: "限量",
      };
    default:
      return {
        color: "gray",
        text: "普通",
      };
  }
};
